(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    function initSortForms(root) {
      var scope = root || document;
      scope.querySelectorAll('.collection-page__sort select[name="sort_by"]').forEach(function (select) {
        if (select.getAttribute('data-collection-sort-init') === '1') return;
        select.setAttribute('data-collection-sort-init', '1');
        select.addEventListener('change', function () {
          var form = select.closest('form');
          if (form) form.submit();
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initSortForms();
      });
    } else {
      initSortForms();
    }

    document.addEventListener('shopify:section:load', function (e) {
      initSortForms(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-card"] && !Shopify.designMode) return;
  try {
    
  class FeatureCardCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-feature-track]');
      this.slides = Array.from(this.querySelectorAll('[data-feature-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-feature-dot]'));
      this.prevBtn = this.querySelector('[data-feature-prev]');
      this.nextBtn = this.querySelector('[data-feature-next]');
      this.activeIndex = 0;
 
      if (this.slides.length <= 1) return;
 
      this.prevBtn?.addEventListener('click', () => this.go(this.activeIndex - 1));
      this.nextBtn?.addEventListener('click', () => this.go(this.activeIndex + 1));
 
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.go(index));
      });
 
      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.go(this.activeIndex - 1);
        if (event.key === 'ArrowRight') this.go(this.activeIndex + 1);
      });
 
      this.setupSwipe();
    }
 
    go(index) {
      const total = this.slides.length;
      this.activeIndex = (index + total) % total;
      this.track.style.transform = `translateX(-${this.activeIndex * 100}%)`;
 
      this.slides.forEach((slide, i) => {
        const isActive = i === this.activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
 
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === this.activeIndex);
      });
    }
 
    setupSwipe() {
      let startX = 0;
 
      this.track.addEventListener('touchstart', (event) => {
        startX = event.touches[0].clientX;
      }, { passive: true });
 
      this.track.addEventListener('touchend', (event) => {
        const endX = event.changedTouches[0].clientX;
        const delta = endX - startX;
        if (Math.abs(delta) > 40) {
          this.go(this.activeIndex + (delta < 0 ? 1 : -1));
        }
      });
    }
  }
 
  if (!customElements.get('feature-card-carousel')) {
    customElements.define('feature-card-carousel', FeatureCardCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-header-root]');
    if (!root) return;

    var drawer = root.querySelector('#header-offcanvas');
    var openBtn = root.querySelector('[data-header-open]');
    var panel = drawer ? drawer.querySelector('.header__drawer-panel') : null;
    var closeEls = drawer ? drawer.querySelectorAll('[data-header-close]') : [];

    if (!drawer || !openBtn || !panel) return;

    var previousFocus = null;

    function setOpen(isOpen) {
      drawer.classList.toggle('header__drawer--open', isOpen);
      drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      openBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.classList.toggle('header-drawer-open', isOpen);

      if (isOpen) {
        drawer.removeAttribute('inert');
        previousFocus = document.activeElement;
        var closeBtn = drawer.querySelector('.header__drawer-close');
        if (closeBtn && typeof closeBtn.focus === 'function') {
          closeBtn.focus();
        }
      } else {
        drawer.setAttribute('inert', '');
        if (previousFocus && typeof previousFocus.focus === 'function') {
          previousFocus.focus();
        }
        previousFocus = null;
      }
    }

    function openDrawer() {
      setOpen(true);
    }

    function closeDrawer() {
      setOpen(false);
    }

    openBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (drawer.classList.contains('header__drawer--open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    closeEls.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closeDrawer();
      });
    });

    var scrollEl = drawer.querySelector('.header__drawer-scroll');
    if (scrollEl) {
      scrollEl.addEventListener('click', function (e) {
        var a = e.target.closest('a[href]');
        if (!a || !scrollEl.contains(a)) return;
        var href = a.getAttribute('href');
        if (!href || href === '#' || href.indexOf('javascript:') === 0) return;
        closeDrawer();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (!drawer.classList.contains('header__drawer--open')) return;
      closeDrawer();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-product-upsells"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('simple-product-upsells')) {
  customElements.define('simple-product-upsells', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const q = selector => this.querySelector(selector);
      const form = q('form');
      if (!form) return;
      const labels = JSON.parse(q('[data-labels]').textContent);
      const select = q('[data-main-variant]');
      const quantity = q('[data-main-quantity]');
      const extras = [...this.querySelectorAll('[data-extra]')];
      const submit = q('[data-submit]');
      const message = q('[data-message]');
      const defaultLabel = submit.textContent.trim();
      const money = n => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.currency || 'USD'}).format(n / 100);
      const optionOf = element => element?.selectedOptions[0];
      let busy = false, completed = false;
      const tilePickers = [];
      const supported = q('[data-product-supported]').dataset.productSupported === 'true';
      function applyRules(input, option, normalize) {
        if (!input || !option) return;
        input.min = option.dataset.min || '1'; input.step = option.dataset.step || '1';
        if (option.dataset.max) input.max = option.dataset.max; else input.removeAttribute('max');
        if (normalize && !input.validity.valid) input.value = input.min;
      }
      const update = () => {
        const selected = optionOf(select);
        const available = supported && selected && !selected.disabled && selected.dataset.available === 'true';
        q('[data-main-controls]').disabled = busy || completed;
        quantity.disabled = !available;
        if (q('[data-extras-controls]')) q('[data-extras-controls]').disabled = busy || completed || !available;
        const price = Number(selected?.dataset.price || 0);
        const compare = Number(selected?.dataset.compare || 0);
        q('[data-main-price]').textContent = money(price);
        q('[data-main-price]').classList.toggle('simple-product__price--sale', compare > price);
        q('[data-main-compare]').textContent = compare > price ? money(compare) : '';
        q('[data-main-compare]').hidden = compare <= price;
        if (q('[data-sku-row]')) { q('[data-sku-row]').hidden = !selected?.dataset.sku; q('[data-sku]').textContent = selected?.dataset.sku || ''; }
        let valid = available && quantity.validity.valid && Number.isSafeInteger(Number(quantity.value));
        let total = valid ? price * Number(quantity.value) : 0;
        q('[data-main-subtotal]').textContent = valid ? quantity.value + ' × ' + money(price) + ' = ' + money(total) : '';
        const summary = q('[data-summary-extras]'); summary.replaceChildren();
        extras.forEach(extra => {
          const included = extra.querySelector('[data-include]').checked;
          const variantSelect = extra.querySelector('[data-extra-variant]');
          const input = extra.querySelector('[data-extra-quantity]');
          if (!variantSelect || !input) return;
          variantSelect.disabled = !included; input.disabled = !included; input.required = included;
          const option = optionOf(variantSelect);
          extra.querySelector('[data-extra-price]').textContent = money(Number(option?.dataset.price || 0));
          if (!included) return;
          if (!option || option.disabled || !input.validity.valid || !Number.isSafeInteger(Number(input.value))) { valid = false; return; }
          const subtotal = Number(option.dataset.price) * Number(input.value); total += subtotal;
          const li = document.createElement('li'); li.textContent = input.value + ' × ' + extra.dataset.title + ' — ' + money(subtotal); summary.append(li);
        });
        this.querySelectorAll('[data-stepper]').forEach(control => {
          const input = control.querySelector('input'); const n = Number(input.value);
          control.querySelectorAll('[data-change]').forEach(button => {
            button.disabled = busy || completed || input.matches(':disabled') || (Number(button.dataset.change) < 0 ? n <= Number(input.min) : input.max !== '' && n >= Number(input.max));
          });
        });
        tilePickers.forEach(picker => {
          picker.tiles.forEach(tile => {
            tile.input.checked = picker.select.value === tile.option.value;
            tile.input.disabled = tile.option.disabled || picker.select.matches(':disabled') || busy || completed;
          });
        });
        q('[data-total]').textContent = valid ? money(total) : '—';
        submit.disabled = busy || completed || !valid;
        if (!busy && !completed) submit.textContent = available ? defaultLabel : labels.sold_out;
      };
      this.querySelectorAll('[data-variant-picker]').forEach((wrapper, pickerIndex) => {
        const sourceSelect = wrapper.querySelector('select');
        if (!sourceSelect || wrapper.hidden || sourceSelect.options.length < 2 || wrapper.dataset.pickerStyle !== 'tiles') return;
        const label = wrapper.querySelector('label');
        const group = document.createElement('div');
        group.className = 'simple-product__variant-tiles';
        group.setAttribute('role', 'radiogroup');
        label.id = label.id || 'SimplePickerLabel-' + this.dataset.sectionId + '-' + pickerIndex;
        group.setAttribute('aria-labelledby', label.id);
        const tiles = [...sourceSelect.options].map(option => {
          const tile = document.createElement('label');
          tile.className = 'simple-product__variant-tile';
          const input = document.createElement('input');
          input.type = 'radio';
          input.name = 'simple-variant-tile-' + this.dataset.sectionId + '-' + pickerIndex;
          input.value = option.value;
          const content = document.createElement('span');
          content.className = 'simple-product__variant-tile-content';
          const name = document.createElement('span');
          name.className = 'simple-product__variant-tile-name';
          name.textContent = option.dataset.title || option.textContent;
          const price = document.createElement('span');
          price.className = 'simple-product__variant-tile-price';
          price.textContent = money(Number(option.dataset.price));
          content.append(name, price);
          if (option.disabled) {
            const state = document.createElement('span');
            state.className = 'simple-product__variant-tile-state';
            state.textContent = labels.sold_out;
            content.append(state);
          }
          input.addEventListener('input', event => event.stopPropagation());
          input.addEventListener('change', () => {
            if (!input.checked || input.disabled) return;
            sourceSelect.value = input.value;
            sourceSelect.dispatchEvent(new Event('change', {bubbles:true}));
          });
          tile.append(input, content);
          group.append(tile);
          return {input, option};
        });
        sourceSelect.hidden = true;
        wrapper.append(group);
        tilePickers.push({select:sourceSelect, tiles});
      });
      applyRules(quantity, optionOf(select), true);
      extras.forEach(extra => applyRules(extra.querySelector('[data-extra-quantity]'), optionOf(extra.querySelector('[data-extra-variant]')), true));
      if (q('[data-extras-controls]') && !extras.length) q('[data-extras-controls]').hidden = true;
      this.querySelectorAll('[data-stepper]').forEach(control => {
        const input = control.querySelector('input');
        control.querySelectorAll('[data-change]').forEach(button => button.addEventListener('click', () => {
          if (button.disabled || input.matches(':disabled')) return;
          input.stepUp(Number(button.dataset.change)); input.dispatchEvent(new Event('input', {bubbles:true}));
        }));
      });
      form.addEventListener('input', update);
      form.addEventListener('change', event => {
        if (event.target === select) {
          applyRules(quantity, optionOf(select), true);
          const url = new URL(window.location.href);
          const productPath = new URL(this.dataset.productUrl, window.location.origin).pathname;
          if (window.location.pathname.replace(/\/$/, '') === productPath.replace(/\/$/, '')) { url.searchParams.set('variant', select.value); window.history.replaceState(null, '', url); }
        }
        if (event.target.matches('[data-extra-variant]')) applyRules(event.target.closest('[data-extra]').querySelector('[data-extra-quantity]'), optionOf(event.target), true);
        update();
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || completed || submit.disabled || !form.reportValidity()) return;
        const chosen = extras.filter(extra => extra.querySelector('[data-include]').checked);
        const group = chosen.length ? (window.crypto?.randomUUID?.() || Date.now() + '-' + Math.random().toString(36).slice(2)) : null;
        const items = [{id:Number(select.value),quantity:Number(quantity.value)}];
        if (group) items[0].properties = {_upsell_group:group};
        for (const extra of chosen) {
          const option = optionOf(extra.querySelector('[data-extra-variant]'));
          const input = extra.querySelector('[data-extra-quantity]');
          if (!option || option.disabled || !input) return;
          items.push({id:Number(option.value),quantity:Number(input.value),properties:{_upsell_group:group}});
        }
        busy = true; update(); submit.textContent = labels.adding; message.textContent = labels.adding;
        try {
          const response = await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || labels.cart_error);
          message.textContent = labels.added; q('[data-view-cart]').hidden = false;
          if (this.dataset.afterAdd === 'cart') { completed = true; window.location.assign(this.dataset.cartUrl); }
          this.dispatchEvent(new CustomEvent('simple-product:added',{bubbles:true,detail:{items:result.items || []}}));
        } catch (error) {
          message.textContent = (error instanceof TypeError ? labels.network_error : error.message) + ' ' + labels.check_cart;
          q('[data-view-cart]').hidden = false;
        } finally { busy = false; update(); if (completed) submit.textContent = labels.added; }
      });
      update();
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
